import { fetchCart } from 'theme';

// Syncs the price-list rendered next to the quick buy title (product-quick-buy.liquid) with the
// one-time/subscription option the shopper has selected. price-list.liquid only knows about the
// variant price, not selling plan adjustments, so without this the header price never changes when
// switching payment tabs/options.
function updatePriceList(option) {
  const productForm = option.getAttribute('data-form-id');
  if (!productForm) return;

  const priceList = document.querySelector('price-list[form="' + productForm + '"]');
  if (!priceList) return;

  const priceValueEl = option.querySelector('.subscription-price');
  if (!priceValueEl) return;

  const saleEl = priceList.querySelector('sale-price');
  const saleValueEl = saleEl?.querySelector('.price-list__price-value');
  if (!saleEl || !saleValueEl) return;

  saleValueEl.textContent = priceValueEl.textContent.trim();

  const originalPriceEl = option.querySelector('.original-price');
  const isOnSale = !!originalPriceEl;

  saleEl.classList.toggle('text-on-sale', isOnSale);
  saleEl.classList.toggle('text-subdued', !isOnSale);

  const compareEl = priceList.querySelector('compare-at-price');
  if (!compareEl) return;

  compareEl.hidden = !isOnSale;

  if (isOnSale) {
    const compareValueEl = compareEl.querySelector('.price-list__price-value');
    if (compareValueEl) compareValueEl.textContent = originalPriceEl.textContent.trim();
  }
}

function setSellingPlans(option) {
  const isSubscripition = option.getAttribute('type') == 'subscription'

  //add selling plan to form
    if (isSubscripition) {
      var product_form = option.getAttribute('data-form-id');
      var selling_plan_id = option.getAttribute('data-selling-plan');

      var formEl = document.getElementById(product_form);
      var existingInput = formEl.querySelector('input[name="selling_plan"]');

      if (existingInput) {
        // Just update the value
        existingInput.value = selling_plan_id;
      } else {
        // Create once if it doesn't exist
        var input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'selling_plan';
        input.value = selling_plan_id;
        formEl.appendChild(input);
      }

      
    } else {
      var product_form = option.getAttribute('data-form-id');
      var formEl = document.getElementById(product_form);
      var existingInput = formEl.querySelector('input[name="selling_plan"]');

      if (existingInput) {
        existingInput.value = ''; // clear instead of adding a duplicate
      } else {
        var input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'selling_plan';
        input.value = '';
        formEl.appendChild(input);
      }

    }

    function updateATCInfo(option) {
      var product_form = option.getAttribute('data-form-id');
      var formEl = document.getElementById(product_form);

      const addToCart = formEl.querySelector('button[type="submit"]');

      if (!addToCart || addToCart.hasAttribute('disabled')) return;

      const price = option.querySelector('.subscription-price');
      const priceValue = price.getAttribute('data-price');

      let innerText = window.innerWidth < 699 || (window.innerWidth >= 1000 && window.innerWidth < 1210) ? option.getAttribute('data-mobile-translation') : option.getAttribute('data-translation');
      innerText = `<span class="text">${innerText}</span>  |  <span class="price">${price.innerHTML}</span>`;

      addToCart.innerHTML = '<span data-price="' + priceValue + '" class="add-to-cart-text">' + innerText + '</span>'

      // QUICK ADD INFO UPDATE
      const quickAdd = document.querySelector('product-quick-add');

      if (!quickAdd) return;

      const targetInfo = quickAdd.querySelectorAll('.target-info');
      const addToCarts = quickAdd.querySelectorAll('button[type="submit"]');
      const targetInfoSellingPlans = quickAdd.querySelectorAll('.target-info h4');
      const priceList = quickAdd.querySelectorAll('.price-list');

      addToCarts.forEach(addToCart => {
        addToCart.innerHTML = '<span class="add-to-cart-text">' + innerText + '</span>'
      });

      targetInfo.forEach(target => {
        if (target.getAttribute('target-info') === option.getAttribute('type')) {
          target.style.display = 'block';
        } else {
          target.style.display = 'none';
        }
      });

      if(selling_plan_id) {
        targetInfoSellingPlans.forEach(h4 => {
          if(h4.getAttribute('data-id') != selling_plan_id) {
            h4.style.display = 'none';
          } else {
            h4.style.display = 'block';
          }
        });
      }
    }

    updateATCInfo(option);
    updatePriceList(option);

    let previousWidth = window.innerWidth;
    
    window.addEventListener('resize', function() {
        const currentWidth = window.innerWidth;
        const wasBelowBreakpoint = previousWidth < 699 || (previousWidth >= 1000 && previousWidth < 1210);
        const isBelowBreakpoint = currentWidth < 699 || (currentWidth >= 1000 && currentWidth < 1210);
        
        if (wasBelowBreakpoint !== isBelowBreakpoint) {
            updateATCInfo(option);
        }
        
        previousWidth = currentWidth;
    });
}

document.addEventListener('variant:change', function(event) {
    let variant = event.detail.variant;
    let bgGradient = document.querySelector('label[data-'+variant.id+'-gradient]').getAttribute('data-'+variant.id+'-gradient');
    let bgBlockColor = document.querySelector('label[data-'+variant.id+'-blockcolour]').getAttribute('data-'+variant.id+'-blockcolour');
    let textColour = document.querySelector('label[data-'+variant.id+'-textcolour]').getAttribute('data-'+variant.id+'-textcolour');
    let shortDescriptionColour = document.querySelector('label[data-'+variant.id+'-textcolour]').getAttribute('data-'+variant.id+'-short-description-colour');

    let gradientElements = document.querySelectorAll('.gradient-change');
    let blockColourElements = document.querySelectorAll('.block-change');
    let textElements = document.querySelectorAll('.text-change');

    if (document.querySelector('quantity-selector') && document.querySelector('quantity-selector').querySelector('input')) {
      document.querySelector('quantity-selector').querySelector('input').value = 1;
    }

    gradientElements.forEach(function(el) {
        el.setAttribute('style', 'background:'+bgGradient+';color:'+textColour);
    });

    blockColourElements.forEach(function(el) {
        el.setAttribute('style', 'background:'+bgBlockColor+';color:'+textColour+';transition:all 250ms ease-in-out;background-position:0% 50%');
    });

    textElements.forEach(function(el) {
        el.setAttribute('style', 'color:'+shortDescriptionColour);
    });

    //set the selector
    const activeOption = document.querySelector('.payment-tab-group .tab.active .payment-option.active');
    if (activeOption) setSellingPlans(activeOption);

    let allGiftInformation = document.querySelectorAll('.gift-information');

    if(allGiftInformation) {
      allGiftInformation.forEach(o => o.classList.remove('active'));

      let giftInformation = document.querySelectorAll('.gift-information[data-id="'+ variant.id +'"]');

      if(giftInformation) {
        giftInformation.forEach(o => o.classList.add('active'));
      }
    }
});

// payment-option changes (delegated handlers)
document.addEventListener('click', function(e) {
  const tabNav = e.target.closest('.payment-tab-group .tab-nav');
  if (!tabNav) return;

  const group = tabNav.closest('.payment-tab-group');
  const target = tabNav.getAttribute('data-target');

  // reset actives within this group
  group.querySelectorAll('.tab-nav').forEach(o => o.classList.remove('active'));
  group.querySelectorAll('.tab').forEach(o => o.classList.remove('active'));
  group.querySelectorAll('.payment-option').forEach(o => o.classList.remove('active'));

  const qtyInput = document.querySelector('quantity-selector')?.querySelector('input');
  if (qtyInput) qtyInput.value = 1;

  tabNav.classList.add('active');
  const activeTab = group.querySelector('.tab[data-id="'+target+'"]');
  if (activeTab) {
    activeTab.classList.add('active');
    const firstOption = activeTab.querySelector('.payment-option:first-of-type');
    if (firstOption) firstOption.classList.add('active');
    const optionPanel = activeTab.querySelector('.payment-option.active');
    if (optionPanel) setSellingPlans(optionPanel);
  }
});

document.addEventListener('click', function(e) {
  const option = e.target.closest('.payment-option');
  if (!option) return;

  const group = option.closest('.payment-tab-group');
  if (!group) return;

  group.querySelectorAll('.payment-option').forEach(o => o.classList.remove('active'));
  option.classList.add('active');
  setSellingPlans(option);
});

//import and extended the accordion functionality
const AccordionDisclosure = customElements.get('accordion-disclosure');

if (AccordionDisclosure) {
  const originalOpenSetter = Object.getOwnPropertyDescriptor(AccordionDisclosure.prototype, 'open').set;

  Object.defineProperty(AccordionDisclosure.prototype, 'open', {
    set: function (value) {
      if (value) {
        // Close all other accordions
        document.querySelectorAll("details[is='accordion-disclosure']").forEach(el => {
          if (el !== this) el.open = false;
        });
      }
      originalOpenSetter.call(this, value);
    }
  });
}

// Initialize the selling_plan hidden input for a subscription selector's active option.
function initializeSellingPlanTabGroup(group) {
  applyDiscountToTabGroup(group);

  const activeOption = group.querySelector('.tab.active .payment-option.active');
  if (activeOption) {
    setSellingPlans(activeOption);
  }
}

document.addEventListener('DOMContentLoaded', function() {
  // Ensure every active option already in the page initializes its selling_plan input on load
  document.querySelectorAll('.payment-tab-group').forEach(initializeSellingPlanTabGroup);
  document.querySelectorAll('price-list[data-discount]').forEach(applyDiscountToPriceList);

  document.addEventListener('quantity-selector:change', function(event) {
    const newQuantity = parseInt(event.detail.quantity);
    const addToCart = document.querySelector('.add-to-cart-text');
    const addToCartQuickAdd = document.querySelector('.product-quick-add .product-quick-add__variant .price');
    const subscriptionPrice = document.querySelector('.active .subscription-price');

    if (addToCart && subscriptionPrice && !isNaN(newQuantity)) {
        const stockPrice = parseFloat(subscriptionPrice.getAttribute('data-stock-price').replace(',', '.'));
        
        if (!isNaN(stockPrice)) {
        const totalPrice = stockPrice * newQuantity;
        addToCart.setAttribute('data-price', totalPrice.toFixed(2));

        const formattedPrice = window.themeVariables.settings.moneyFormat.replace(/\{\{[^}]+\}\}/g, totalPrice.toFixed(2));
        const priceElement = addToCart.querySelector('.price');
        
        if (priceElement) {
          priceElement.innerText = formattedPrice;
        }

        if (addToCartQuickAdd) {
          addToCartQuickAdd.innerText = formattedPrice;
        }
      }
    }
  });
});

// Subscription selectors rendered after the initial page load (quick buy drawer, quick add,
// product re-renders) never fire DOMContentLoaded, so without this their selling_plan input
// only gets created once the shopper re-clicks the already-"active" option.
new MutationObserver(function(mutations) {
  mutations.forEach(function(mutation) {
    mutation.addedNodes.forEach(function(node) {
      if (!(node instanceof Element)) return;
      if (node.matches('.payment-tab-group')) {
        initializeSellingPlanTabGroup(node);
      }
      node.querySelectorAll?.('.payment-tab-group').forEach(initializeSellingPlanTabGroup);

      if (node.matches('price-list[data-discount]')) {
        applyDiscountToPriceList(node);
      }
      node.querySelectorAll?.('price-list[data-discount]').forEach(applyDiscountToPriceList);
    });
  });
}).observe(document.documentElement, { childList: true, subtree: true });

// Keep the quick buy drawer in sync with the variant selected via the product card's swatches.
// <quick-buy-drawer handle="..."> is only ever set from the card's default variant at render
// time, and its content is cached after first load, so without this it always opens showing the
// default variant regardless of which swatch is selected.
document.addEventListener('change', function(e) {
  const swatchInput = e.target.closest('.product-card__swatch-list [type="radio"], .product-card__variant-list [type="radio"]');
  if (!swatchInput || !swatchInput.hasAttribute('data-variant-id')) return;

  const card = swatchInput.closest('product-card');
  const quickBuyDrawer = card?.querySelector('quick-buy-drawer');
  if (!quickBuyDrawer) return;

  const productHandle = card.getAttribute('handle');
  quickBuyDrawer.setAttribute('handle', `${productHandle}?variant=${swatchInput.getAttribute('data-variant-id')}`);
  quickBuyDrawer._hasLoaded = false;
});

/*octane quiz*/
document.addEventListener('octane.quiz.completed', function (event) {
  const quizData = event.detail || {};
  const email = quizData.email;
  if (!email) return;

  // Flatten all sections, de-duplicating by product ID
  const seen = new Set();
  const products = (quizData.sections || [])
    .flatMap(section => section.products || [])
    .filter(p => p && p.id && !seen.has(p.id) && seen.add(p.id));
  if (!products.length) return;

  // Rewrite links onto the live domain (Octane may return the .myshopify.com URL)
  const toLiveUrl = (link) => {
    try { return window.location.origin + new URL(link).pathname; }
    catch (e) { return link || null; }
  };

  const toKlaviyoProduct = (p) => {
    const variant = (p.variants || [])[0] || {};
    return {
      id: String(p.id),
      name: p.title,
      url: toLiveUrl(p.link),
      image: p.image || null,
      price: p.price_formatted || variant.price_formatted || null,
      compare_at_price: variant.compare_at_price_formatted || null
    };
  };

  const cleaned = products.map(toKlaviyoProduct);
  const primary = cleaned[0];
  const recs = cleaned.slice(1);

  const properties = {
    // Existing properties, kept so current flow logic doesn't break
    'Primary Product': primary.name,
    'Product Recommendations': recs.map(r => r.name),

    // Structured data for email blocks
    PrimaryProductDetails: primary,
    ProductRecommendationItems: recs,
    QuizResultsUrl: quizData.quiz_results_url || null
  };

  if (typeof klaviyo !== 'undefined') {
    klaviyo.push(['identify', { '$email': email }]);
    klaviyo.push(['track', 'Quiz Products Recommended', properties]);
  }
});

const APPLIED_KEY = 'tonic:discount-applied';

const discountConfig = window.personalisedDiscount || { offers: [], strings: {} };

// Shared with the <head> script; only used once there are offers, which is when it's defined
const discountStorage = discountConfig.storage;

// Resolved in snippets/personalised-discount.liquid so it's known before the page is drawn
const discountOffer = discountConfig.active || null;

function isDiscountEligible(codes) {
  if (!discountOffer || !codes) return false;

  return codes.split(',').some(code => code.trim().toUpperCase() === discountOffer.code.toUpperCase());
}

function discountAppliesTo(type) {
  return discountOffer.appliesTo === 'all' || discountOffer.appliesTo === 'both' || discountOffer.appliesTo === type;
}

function getDiscountedPrice(cents) {
  return Math.round(cents * (100 - discountOffer.percentage) / 100);
}

function formatDiscountMoney(cents, withCurrency) {
  const settings = window.themeVariables.settings;
  const format = withCurrency ? settings.moneyWithCurrencyFormat : settings.moneyFormat;

  return format.replace(/\{\{\s*(\w+)\s*\}\}/, (match, type) => {
    const [whole, decimals] = (cents / 100).toFixed(2).split('.');

    switch (type) {
      case 'amount_no_decimals':
        return Math.round(cents / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      case 'amount_with_comma_separator':
        return whole.replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + decimals;
      case 'amount_no_decimals_with_comma_separator':
        return Math.round(cents / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      default:
        return whole.replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + decimals;
    }
  });
}

function formatDiscountPercentage(value) {
  return (Math.round(value * 10) / 10).toString();
}

function applyDiscountToPriceList(priceList) {
  if (!discountOffer || priceList.hasAttribute('data-discount-applied')) return;

  let data;

  try {
    data = JSON.parse(priceList.getAttribute('data-discount'));
  } catch (e) {
    return;
  }

  if (!isDiscountEligible(data.codes)) return;

  const prices = [];
  const discountedPrices = [];

  if (data.one_time != null) {
    prices.push(data.one_time);
    discountedPrices.push(discountAppliesTo('one_time') ? getDiscountedPrice(data.one_time) : data.one_time);
  }

  if (data.subscription != null) {
    prices.push(data.subscription);
    discountedPrices.push(discountAppliesTo('subscription') ? getDiscountedPrice(data.subscription) : data.subscription);
  }

  if (!discountedPrices.length) return;

  const price = Math.min(...discountedPrices);

  if (price >= Math.min(...prices)) return;

  const compare = Math.max(data.compare || 0, data.one_time || 0);
  const strings = discountConfig.strings;

  let html = `<sale-price class="${data.sale_class}"><span class="sr-only">${strings.salePrice}</span>${data.from ? strings.from : ''}<span class="price-list__price-value">${formatDiscountMoney(price, data.currency)}</span></sale-price>`;

  if (compare > price) {
    html += `<compare-at-price class="${data.compare_class}"><span class="sr-only">${strings.regularPrice}</span><span class="price-list__price-value">${formatDiscountMoney(compare, data.currency)}</span></compare-at-price>`;
  }

  priceList.querySelectorAll(':scope > sale-price, :scope > compare-at-price, :scope > .savings-info').forEach(el => el.remove());
  priceList.insertAdjacentHTML('afterbegin', html);
  priceList.setAttribute('data-discount-applied', '');
}

function applyDiscountToTabGroup(group) {
  if (!isDiscountEligible(group.getAttribute('data-discount-codes'))) return;

  const servings = parseFloat(group.getAttribute('data-servings'));

  group.querySelectorAll('.payment-option').forEach(option => {
    if (option.hasAttribute('data-discount-applied')) return;

    const type = option.getAttribute('type') === 'subscription' ? 'subscription' : 'one_time';
    const priceEl = option.querySelector('.subscription-price[data-discount-price]');

    if (!discountAppliesTo(type) || !priceEl) return;

    const full = Math.round(parseFloat(priceEl.getAttribute('data-discount-full')));
    const price = getDiscountedPrice(parseFloat(priceEl.getAttribute('data-discount-price')));

    priceEl.textContent = formatDiscountMoney(price);
    priceEl.setAttribute('data-stock-price', (price / 100).toFixed(2));

    let originalEl = option.querySelector('.original-price');

    if (!originalEl) {
      originalEl = document.createElement('span');
      originalEl.className = 'original-price';
      originalEl.innerHTML = `<s>${formatDiscountMoney(full)}</s>`;
      priceEl.before(originalEl);
    }

    let badge = option.querySelector('.percentage-off');

    if (!badge) {
      badge = document.createElement('span');
      badge.className = 'percentage-off badge';
      (originalEl.closest('.wrapper') || originalEl).before(badge);
    }

    badge.textContent = `${formatDiscountPercentage((full - price) / full * 100)}% Off`;

    const servingEl = option.querySelector('.price-per-serving');

    if (servingEl && servings) {
      servingEl.textContent = servingEl.textContent.replace(/^\s*[\d.,]+/, Math.round(price / servings));
    }

    option.setAttribute('data-discount-applied', '');
  });
}

async function syncCartDiscount() {
  if (!discountConfig.offers.length) return;

  const cart = await fetchCart;
  const appliedCodes = (cart.discount_codes || []).map(discount => discount.code);
  const isApplied = code => appliedCodes.some(applied => applied.toUpperCase() === code.toUpperCase());
  const root = window.Shopify?.routes?.root || '/';

  if (discountOffer) {
    if (isApplied(discountOffer.code)) return;
    if (!cart.item_count && discountStorage.get('sessionStorage', APPLIED_KEY) === discountOffer.code) return;

    await fetch(`${root}discount/${encodeURIComponent(discountOffer.code)}?redirect=${encodeURIComponent(root + 'cart.js')}`);
    discountStorage.set('sessionStorage', APPLIED_KEY, discountOffer.code);
  } else {
    const staleCodes = discountConfig.offers.map(offer => offer.code).filter(isApplied);

    if (!staleCodes.length) return;

    const remainingCodes = appliedCodes.filter(code => !staleCodes.some(stale => stale.toUpperCase() === code.toUpperCase()));

    await fetch(`${root}cart/update.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ discount: remainingCodes.join(',') })
    });

    document.cookie = 'discount_code=; path=/; max-age=0';
  }

  document.dispatchEvent(new CustomEvent('cart:refresh'));
  window.Rebuy?.Cart?.fetchCart?.();
}

syncCartDiscount().catch(() => {});